import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostMenuRequest } from '../models/responseModels'
import { CommonPostResponse } from '../../../components/models/models'

export class PostMenuApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/menu/add',
      requesterInfo,
    })
  }

  public async addMenu(request: IPostMenuRequest): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
